import React, {Component} from "react";
import {Link, NavLink, Redirect, Route} from "react-router-dom";
import InfiniteScroll from 'react-infinite-scroller';
import PropTypes from 'prop-types';
import FallbackImage from "react-image-fallback";
import * as moment from "moment";
import DatePicker from 'react-datepicker';

import {clamp, mapObjectToArray, testPath} from "../../lib/tools";
import {FormContext, RouteContext} from "../../contexts";
import {getImage} from "../../lib/api";
//Icons
import arrowBlackIcon from "../../resources/icons/ic-arrow-back.svg";
import addWhiteIcon from "../../resources/icons/add-white.svg";
import minusWhiteIcon from "../../resources/icons/minus-white.svg";
import plusWhiteIcon from "../../resources/icons/plus-white.svg";
import facebookWhiteIcon from "../../resources/icons/facebook-white.svg";
import visaIcon from "../../resources/icons/visa2.svg";
import mastercardIcon from "../../resources/icons/mastercard2.svg";
import mobilepayIcon from "../../resources/icons/mobilepay.svg";
//Images
import placeholderImage from "../../resources/images/placeholder.png";


//New design:
export const BackBtn = ({to}) => (
	<Link to={to}>
		<img src={arrowBlackIcon} alt="tilbage"/>
	</Link>
);

export const TileLink = ({className, children, img, to}) => (
	<Link title="" className={["tileLink", className].join(" ")} to={to}>
		{
			img &&
			<img src={getImage(img)} alt="kategori"/>
		}
		<div>
			<img src={addWhiteIcon}/>
			<span>{children}</span>
		</div>
	</Link>
);
TileLink.propTypes = {
	className: PropTypes.string
};

// Quantity selector with +, - and input options 
export const QtySelector = ({value, onChange, max = 99, min = 1}) => (
	<div className="qtySelect">
		<div className="decrease" onClick={() => onChange(clamp(value - 1, min, max))}>
			<img src={minusWhiteIcon} alt="minus"/>
		</div>
		<input 
			type="number" 
			value={value ? value : 0}
			onKeyDown={e => e.key === "Enter" && e.currentTarget.blur()}
			onChange={e => onChange(e.target.value)}
			onBlur={() => onChange(clamp(value, min, max))}
		/>
		<div className="increase" onClick={() => onChange(clamp(value + 1, min, max))}>
		<img src={plusWhiteIcon} alt="minus"/>
		</div>
	</div>
);

QtySelector.propTypes = {
	value: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	max: PropTypes.number,
	isProduct: PropTypes.bool
};











//<editor-fold desc="Buttons">
//A button component
//Used for all buttons in app, can be text and link.
export class Button extends Component {
	static propTypes = {
		className: PropTypes.string,
		icon: PropTypes.string
	};
	
	static contextType = FormContext;
	
	render() {
		const {className, id, to, noFocus, disable, innerRef, blank, children, submit, ...props} = this.props;
		const onClick = submit ? this.context.onSubmit : props.onClick;
		
		let classes = [
			"btn"
		];
		className && classes.push(className);
		disable && classes.push("disabled");
		if (to) {
			return (
				<NavLink
					onMouseDown={e => noFocus && e.preventDefault()}
					to={to}
					onClick={disable ? null : onClick}
					innerRef={innerRef}
					target={blank ? "_blank" : ""}
					className={classes.join(" ")}
				>
					{children}
				</NavLink>
			)
		} else {
			return (
				<div
					{...props}
					onMouseDown={e => noFocus && e.preventDefault()}
					onClick={disable ? null : onClick}
					ref={innerRef}
					className={classes.join(" ")}
					id={id}
				>
					{children}
				</div>
			)
		}
	}
}
//</editor-fold>

//<editor-fold desc="Form Elements">
export const HiddenSubmit = (props) => (
	<input type="submit" style={{display: "none"}}/>
);

export const TextField = ({onChange, type, name, value, placeholder, icon}) => (
	<input
		onChange={e => onChange(e.target.value, e.target.name)}
		type={type || "text"}
		name={name}
		value={value}
		placeholder={placeholder}
		style={{backgroundImage: `url(${icon})`}}
	/>
);

export const SimpleTextField = ({className, error, onChange, type, name, value, placeholder, title, icon}) => (
	<label className={["textInputWrapper", className, error ? "error" : ""].join(" ")}>
		{title}
		<TextField onChange={onChange} type={type} name={name} value={value} placeholder={placeholder} icon={icon}/>
		{error && <span className="errorText">{error}</span>}
	</label>
);

export class SearchField extends Component {
	state = {
		value: ""
	};
	
	constructor(props) {
		super(props);
		
		this.onChange = (e) => {
			const val = e.target.value;
			this.setState({value: val});
			this.props.onChange && this.props.onChange(val);
		};
		
		this.onEnter = e => {
			if (e.key === "Enter") {
				e.preventDefault();
				this.props.onSubmit && this.props.onSubmit(e.target.value);
			}
		};
	}
	
	
	render() {
		const {className, onSubmit} = this.props;
		const value = this.props.hasOwnProperty("value") ? this.props.value : this.state.value;
		
		return (
			<input
				className={["searchField", className].join(" ")}
				type="search"
				value={value}
				onChange={this.onChange}
				ref={element => (element || {}).onsearch = e => onSubmit && onSubmit(e.target.value)}
				placeholder="Søg"
				onKeyDown={this.onEnter}
			/>
		);
	}
}

export const RadioGroup = ({value, onChange, radios}) => (
	<div className="radioGroup">
		{mapObjectToArray(radios, (x, i) => <RadioButton key={i} id={i} value={value} onChange={onChange} {...x}/>)}
	</div>
);

export const RadioButton = ({id, value, onChange, icon, className, label, title, price}) => (
	<label>
		<div className={["customRadio", value === id ? "active" : "inactive", className].join(" ")}
		     onClick={() => onChange(id)}>
			<img src={icon} alt="checkbox" className="icon"/>
		</div>
		{label}
		{title && <span>{title}</span>}
		{price && <span className="price">{price}</span>}
	</label>
);
//</editor-fold>

export const LoadingSpinner = () => (
	<div className="dotLoading">
		<div className="dot"/>
		<div className="dot"/>
		<div className="dot"/>
	</div>
);

export class FileSelect extends React.Component {
	state = {
		file: null
	};
	
    constructor(props) {
        super(props);
        
        this.onClick = () => {
            if (this.state.file) {
                if (this.props.onUpload) {
	                this.props.onUpload(this.state.file);
	                this.upload.value = "";
	                this.setState({file: null});
                }
            } else {
            	this.upload.click();
            }
        };
        
        this.onSelect = e => {
	        let file = e ? e.target.files[0] : null;
	        this.setState({file: file});
	        
	        if (this.props.instant)
		        this.onClick();
	        
	        if (file == null) this.upload.value = "";
	        
	        this.props.onSelect && this.props.onSelect(file);
        };
    }
    
    render() {
        return (
            <div className="fileSelect">
	            <p className="fileName">{this.state.file ? this.state.file.name : "Ingen fil valgt"}</p>
	            <Button className="btnGreen" onClick={this.onClick}>
		            {this.state.file && this.props.hasOwnProperty("onUpload") ? "Upload" : "Vælg"}
	            </Button>
	            <input type="file" ref={r => this.upload = r} onChange={this.onSelect} accept={this.props.accept} style={{display: "none"}}/>
            </div>
        );
    }
}

//An override for infiniteScroll setting #content as the scrollable container
export class ContentInfiniteScroll extends InfiniteScroll {
	getParentElement(el) {
		if (this.props.scrollParent) {
			return this.props.scrollParent;
		}
		return document.getElementById(this.props.parent || "content");
	}
}

export class InfinityScroll extends React.Component {
	static propTypes = {
		loadMore: PropTypes.func,
		loadCount: PropTypes.number
	};
	
	mounted = true;
	
	constructor(props) {
		super(props);
		
		this.loadKey = null;
		
		this.loadMore = (page) => {
			this.setState({loading: true, hasMore: false});
			this.props.loadMore(page, this.props.loadCount)
				.then(amount => this.mounted && this.setState({
					loading: false,
					hasMore: amount >= this.props.loadCount
				}))
		}
	}
	
	componentWillUnmount() {
		this.mounted = false;
	}
	
	state = {
		hasMore: true,
		loading: false
	};
	
	render() {
		const {children, className, parent, loadKey} = this.props;
		
		if (loadKey !== this.loadKey) {
			this.loadKey = loadKey;
			if (!this.state.hasMore)
				this.setState({hasMore: true});
		}
		
		return (
			<ContentInfiniteScroll className={className} pageStart={0} loadMore={this.loadMore}
			                       hasMore={this.state.hasMore}
			                       useWindow={false} parent={parent}>
				{children}
				{this.state.loading && <LoadingSpinner/>}
			</ContentInfiniteScroll>
		);
	}
}

//Rendering for a button version of the date picker
export class DatePickerButtonRender extends Component {
	render() {
		const {onClick, value, fakePlaceholder} = this.props;
		return (
			<div className="datepickerButton" onClick={onClick}>
				{
					!value ? 
					<span className="fakePlaceholder">{fakePlaceholder}</span> :
					<span className="selection">{value}</span>
				}
				
			</div>
		);
	}
}

DatePickerButtonRender.propTypes = {
	onClick: PropTypes.func,
	value: PropTypes.any,
	fakePlaceholder: PropTypes.string
};

//A button version of the date picker
export const DatePickerButton = ({selected, ...props}) => (
	<DatePicker {...props}
	            selected={selected ? (moment.isMoment(selected) ? selected : moment(selected)) : null}
	            customInput={<DatePickerButtonRender fakePlaceholder={props.fakePlaceholder}/>}/>
);

export const Image = (props) => <FallbackImage {...props} fallbackImage={placeholderImage}
                                               initialImage={<LoadingSpinner/>}/>;


//Wrapper for realative routing
export class RelativeRoute extends React.Component {
	static contextType = RouteContext;
	
	render() {
		const {path, ...props} = this.props;
		
		const newRoute = path ?
			"/" + (this.context.route + "/" + path.replace(/(?:^\/*|\/*$)/g, "")).replace(/^\/*/g, "") :
			this.context.route;
		
		return (
			<RouteContext.Provider value={{route: newRoute}}>
				<Route {...props} path={newRoute}/>
			</RouteContext.Provider>
		);
	}
}

// Switch wrapper for relative routing
export class RelativeSwitch extends React.Component {
	
	static contextType = RouteContext;
	
	static propTypes = {
		children: PropTypes.node
	};
	
	render() {
		const {children} = this.props;
		let newChildren = [];
		
		let match = null;
		React.Children.forEach(children, (child, index) => {
			if (!React.isValidElement(child)) return;
			
			if (child.type !== Route) {
				if (child.type === Redirect) {
					if (child.props.from && !testPath(child.props.from, {exact: true}))
						return;
				}
				
				newChildren.push(React.cloneElement(child, {key: index}));
				
				return;
			} else if (match)
				return;
			
			const {path, ...props} = child.props;
			const newRoute = path ?
				"/" + (this.context.route + "/" + path.replace(/(?:^\/*|\/*$)/g, "")).replace(/^\/*/g, "") :
				this.context.route;
			
			match = testPath(newRoute, props);
			if (match) {
				newChildren.push(React.cloneElement(child, {
					location: window.location,
					computedMatch: match,
					key: index
				}));
			}
		}, this);
		
		return (
			<RouteContext.Provider value={{route: match ? match.path : this.context.route}}>
				{newChildren}
			</RouteContext.Provider>
		)
	}
}

export class Carousel extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.onChange = (x) => {
			this.props.onChange && this.props.onChange(x);
			this.setState({selection: x});
		}
	}
	
	
	state = {
		selection: 0
	};
	
	render() {
		const {images = []} = this.props;
		let value = this.props.hasOwnProperty("value") ? this.props.value : this.state.selection;
		value = images.includes(value) ? value : images[0] || null;
		return (
			<div className="carouselWrapper">
				<div className="imageContainer">
					<Image src={getImage(value)}/>
				</div>
				{images.length > 1 && <div className="imageList">
					{images.map(x =>
						<Image className={"imagePreview" + (value === x ? " selected" : "")} src={getImage(x)}
						       onClick={() => this.onChange(x)} key={x}/>
					)}
				</div>}
			</div>
		);
	}
}

export const Footer = () => (
	<footer>
		<div className="maxWidth">
			
			<div className="footerSection">
				<Link to="handelsbetingelser">Betingelser</Link>
				<Link to="levering">Levering</Link>
				<Link to="brugsbetingelser-datapolitik">Datapolitik</Link>
				<Link to="cookies">Cookies</Link>
				<Link to="konkurrence/betingelser">Konkurrence</Link>
				{/* <Link to="mine-sider/kontakt">Kontakt os</Link> */}
			</div>

			<div className="footerSection">
				<span className="bold">Festen.dk</span>
				<span>CVR. 34725195</span>
				<div className="iconsContainer">
					<div className="iconWrapper"><img src={visaIcon} alt="Visa"/></div>
					<div className="iconWrapper"><img src={mastercardIcon} alt="Mastercard"/></div>
					<div className="iconWrapper"><img src={mobilepayIcon} alt="Mobilepay"/></div>
				</div>
			</div>
			
			<div className="footerSection">
				<span>Thujavej 13</span>
				<span>DK-5250 Odense SV</span>
				{/* <span>Tel. +45 78707888</span> */}
				<span>kontakt@festen.dk</span>

				<a className="facebook" href="https://www.facebook.com/festen.dk/">
					<img src={facebookWhiteIcon} alt="Facebook"/>
				</a>
			</div>
			
		</div>
	</footer>
);


// WEBPACK FOOTER //
// ./src/components/common/common.js